import React, { createContext, useState, useEffect } from "react";
import axios from "axios";
// Create the BusinessContext
export const BusinessContext = createContext();

const BusinessProvider = ({ children }) => {
  const [business, setBusiness] = useState(null);
  const [loading, setLoading] = useState(true);
  const [accountDetails, setAccountDetails] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Extract the subdomain from the current window's hostname
    const hostname = window.location.hostname;
    const subdomain = hostname.split(".")[0]; // Assumes subdomain is the first segment

    // Fetch business details using the subdomain
    const fetchBusinessDetails = async () => {
      try {
        const response = await fetch(
          `https://api.octavio.co/business/details/${subdomain}`
        );
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const data = await response.json();
        setBusiness(data);
        console.log(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBusinessDetails();
  }, []);

  const fetchAccountDetails = async (id) => {
    try {
      const res = await axios.get(
        `https://api.octavio.co/accounts/details/${id}`
      );
      setAccountDetails(res.data);
    } catch (error) {
      console.log(error, "error>>>>>>>>>>");
    }
  };

  useEffect(() => {
    if (business?.account_id) {
      fetchAccountDetails(business.account_id);
    }
  }, [business]);

  return (
    <BusinessContext.Provider
      value={{ business, accountDetails, loading, error }}
    >
      {children}
    </BusinessContext.Provider>
  );
};

export default BusinessProvider;
